import { useCallback, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState, useAppDispatch } from 'store';
import departmentsService from 'services/departmentsService';
import PositionsService from 'services/positionService';
import workersService from 'services/wokersService';
import { getUser } from 'store/user/user';
import { IWorkersOptions } from './FilterBox/hook';
import { isUserGuest } from 'utils/helper/workerHelper';
import { IWorkerIdentSortValue } from 'models';
import { workerIdentSortTypes } from 'utils/constants';
export type ReceivedProps = Record<string, any>;

const useSchedules = (props: ReceivedProps) => {
    const { userData } = useSelector((state: RootState) => state.users);
    let checkUserGuest = isUserGuest(userData); 
    const dispatch = useAppDispatch();
    const [openScheduleFormDialog, setOpenScheduleFormDialog] =
        useState<boolean>(false);
    const [openDeleteConfirmationDialog, setOpenDeleteConfirmationDialog] =
        useState<boolean>(false);
    const [openPlanUpdateModal, setOpenPlanUpdateModal] = useState<boolean>(false);
    const [activeTab, setActiveTab] = useState<number>(userData.worker && !checkUserGuest ? 0 : 1);
    const [workerOptions, setWorkerOptions] = useState<IWorkersOptions[]>();
    const [positionOptions, setPositionOptions] = useState<
        {
            id: any;
            name: string;
        }[]
    >();
    const [departmentOptions, setDepartmentOptions] = useState<
        {
            id: any;
            name: string;
        }[]
    >();
    const [searchParam, setSearchParam] = useState<any>({});
    const [hasCalendarPermission, setHasCalendarPermission] = useState<any>(userData.has_permission_google_calendar);
    const [identSort, setIdentSort] = useState<IWorkerIdentSortValue | null>(workerIdentSortTypes[0]);

    const fetchWorkers = useCallback(async () => {
        try {
            const { workers } = await workersService.getListWorkers({
                page: 1,
                per_page: 9999,
            });
            setWorkerOptions(
                workers.map((item) => ({
                    id: item.id,
                    name: item.name,
                    identification: item.identification,
                    departments: item?.departments?.length > 0 ? item?.departments?.map(v => v.id) : null,
                    position: item?.position ? item?.position?.id : null,
                    departments2: item?.departments
                })),
            );
        } catch (error) {
            //
        }
    }, []);

    const fetchPositions = useCallback(async () => {
        try {
            const { positions } = await PositionsService.getListPositions({
                page: 1,
                per_page: 9999,
            });
            setPositionOptions(
                positions.map((item) => ({
                    id: item.id,
                    name: item.name,
                })),
            );
        } catch (error) {
            //
        }
    }, []);

    const fetchDepartments = useCallback(async () => {
        try {
            const { departments } =
                await departmentsService.getListDepartments();
            setDepartmentOptions(
                departments.map((item) => ({
                    id: item.id,
                    name: item.name,
                })),
            );
        } catch (error) {
            //
        }
    }, []);

    useEffect(() => {
        fetchWorkers();
        fetchPositions();
        fetchDepartments();
    }, [fetchWorkers, fetchPositions, fetchDepartments]);

    const getMe = async () => {
        const response = await dispatch(getUser());
        return response;
    }

    const onGoogleAuthenticate = () => {
        const googleURL = userData?.google_calendar_url || '';
        const returned = window.open(googleURL, '_blank');
        let timer = setInterval(async function () {
            if (returned?.closed) {
                clearInterval(timer);
                // console.log('close my man');
                const response = await getMe();
                if (response && response.payload && response.payload.user) {
                    if (response.payload.user.has_permission_google_calendar) {
                        setHasCalendarPermission(true);
                    } else {
                        setHasCalendarPermission(false);
                    }
                }
            }
        }, 500);
    }

    return {
        ...props,
        openScheduleFormDialog,
        openDeleteConfirmationDialog,
        openPlanUpdateModal,
        activeTab,
        workerOptions,
        positionOptions,
        departmentOptions,
        searchParam,
        setSearchParam,
        setActiveTab,
        setOpenDeleteConfirmationDialog,
        setOpenScheduleFormDialog,
        setOpenPlanUpdateModal,
        onGoogleAuthenticate,
        hasCalendarPermission,
        identSort,
        setIdentSort,
    };
};

export type Props = ReturnType<typeof useSchedules>;

export default useSchedules;
